import { create } from 'zustand';

import { vhAdmGetCurrentUser } from '@/admin/admin.api';

// The live API returns "super-admin" (hyphen) even though the swagger docs say
// "super_admin" (underscore) — accept both so a docs fix upstream doesn't lock everyone out.
const SYSTEM_ADMIN_ROLES = new Set(['admin', 'super_admin', 'super-admin']);

export type VhAdminAccessStatus = 'idle' | 'checking' | 'allowed' | 'denied';

type VhAdminAccessState = {
  status: VhAdminAccessStatus;
  /** Fetches the current user's AUTH role once and caches the verdict — safe to
   *  call from every consumer (guard, header link, ...) without refetching. */
  check: () => Promise<void>;
};

export const useVhAdminAccessStore = create<VhAdminAccessState>((set, get) => ({
  status: 'idle',
  check: async () => {
    if (get().status !== 'idle') return;

    set({ status: 'checking' });
    try {
      const user = await vhAdmGetCurrentUser();
      set({ status: SYSTEM_ADMIN_ROLES.has(user.role) ? 'allowed' : 'denied' });
    } catch {
      set({ status: 'denied' });
    }
  },
}));
